<template>
  <div class="auth-block pb-144 pt-144">
    <portal to="modal">
      <BuyCard v-if="buy_card_modal" />
      <CheckRemainder v-if="check_remainder_modal" />
    </portal>

    <!-- <span style="text-transform: none;">{{
      _.get($store.state.main.indx, "unicardAuthUrl")
    }}</span> -->

    <div class="auth-block__inner container grid" v-if="!gift_card.length">
      <div class="auth-block__box flex column">
        <h2 class="f-34 medium uppercase mb-34">{{ $fn.tr("რეგისტრაცია") }}</h2>
        <div
          class="auth-block__box--teaser"
          v-html="$fn.tr('registration form teaser')"
        ></div>
        <router-link
          :to="register_link.full_url"
          class="auth-block__button flex justify-center al-center pointer"
        >
          <span class="f-white pangram-extrabold f-16">{{
            $fn.tr("დაწყება")
          }}</span>
        </router-link>
      </div>

      <div class="auth-block__box flex column">
        <h2 class="f-34 medium uppercase mb-34">{{ $fn.tr("ავტორიზაცია") }}</h2>
        <div
          class="auth-block__box--teaser"
          v-html="$fn.tr('authorization form teaser')"
        ></div>
        <a
          :href="_.get($store.state.main.indx, 'unicardAuthUrl')"
          class="auth-block__button flex justify-center al-center pointer"
          v-if="!this.$cookies.get('_uctoken')"
        >
          <span class="f-white pangram-extrabold f-16">{{
            $fn.tr("შესვლა")
          }}</span>
        </a>
        <router-link
          :to="_.get(cabinet_link, 'full_url')"
          class="auth-block__button flex justify-center al-center pointer"
          v-else
        >
          <span class="f-white pangram-extrabold f-16">{{
            $fn.tr("შესვლა")
          }}</span>
        </router-link>
      </div>
    </div>

    <div class="auth-block__inner container grid" v-if="gift_card.length">
      <div class="auth-block__box flex column" v-for="(it, i) in cont" :key="i">
        <h2 class="f-34 medium uppercase mb-34">{{ _.get(it, "title") }}</h2>
        <div
          class="auth-block__box--teaser"
          v-html="_.get(it, 'content')"
        ></div>
        <div
          class="auth-block__button flex justify-center al-center pointer"
          @click="toggle(i)"
        >
          <span class="f-white pangram-extrabold f-16">{{
            _.get(it, "button_name")
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BuyCard from "@/components/modals/BuyCard";
import CheckRemainder from "@/components/modals/CheckRemainder";
import getCardData from "../../mixins/getCardData";
export default {
  mixins: [getCardData],
  components: {
    BuyCard,
    CheckRemainder
  },
  props: {
    contentData: Object
  },

  computed: {
    cont() {
      return _.get(this.contentData, "data.list[0].content.tabs");
    },
    gift_card() {
      return _.get(this.contentData, "conf.conf");
    },
    buy_card_modal() {
      return this.$store.state.main.buy_card_modal;
    },
    check_remainder_modal() {
      return this.$store.state.main.check_remainder_modal;
    },

    register_link() {
      return this.$store.state.main.indx.menus.filter(menu =>
        menu.configs.includes("register-page")
      )[0];
    },
    cabinet_link() {
      return this.$store.state.main.indx.menus.filter(menu =>
        menu.configs.includes("cabinet-page")
      )[0];
    }
  },
  methods: {
    toggle(idx) {
      if (idx === 0) {
        this.$store.commit("main/setState", {
          key: "buy_card_modal",
          val: true
        });
      } else {
        this.$store.commit("main/setState", {
          key: "check_remainder_modal",
          val: true
        });
      }
    }
  }
};
</script>

<style lang="scss">
.auth-block {
  background-color: #f7f7f7;
  &__inner {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 30px;
  }
  &__box {
    position: relative;
    border: #dbdbdc 2px solid;
    border-radius: 18px;
    padding-left: 55px;
    padding-top: 60px;
    padding-bottom: 154px;
    padding-right: 163px;
    &--teaser {
      p,
      li,
      ul,
      span,
      h1,
      h2,
      h3,
      h4,
      h5 {
        // font-family: "Hm-Pangram-bold";
        font-family: "Firago-Book";
        font-size: 14px;
        line-height: 20px;
        color: #4d4d4f;
      }
    }
  }
  &__button {
    position: absolute;
    bottom: 60px;
    left: 60px;
    background-color: #4d4d4f;
    width: fit-content;
    padding-left: 87px;
    padding-right: 87px;
    height: 60px;
    transition: 0.4s;
    max-width: calc(100% - 70px);
    @include hover {
      background-color: #1a1a1a;
    }
  }
  p {
    width: 496px;
    @include clamp(3);
  }
  @media (max-width: 1550px) {
    &__box {
      padding-right: 34px;
      padding-left: 34px;
    }
    &__button {
      left: 34px;
    }
    p {
      width: 100%;
    }
  }
  @media (max-width: 1023px) {
    padding-top: 89px;
    padding-bottom: 89px;
    &__inner {
      grid-template-columns: 1fr;
      grid-row-gap: 34px;
    }

    &__button {
      left: 30px;
    }
    p {
      width: 100%;
    }
  }
  @media (max-width: 767px) {
    padding-bottom: 55px;
    padding-top: 55px;
  }
  @media (max-width: 413px) {
    &__box {
      padding-left: 17px;
      padding-right: 17px;
    }
    &__button {
      left: 17px;
      padding-left: 34px;
      padding-right: 34px;
    }
  }
}
</style>
